import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-customer-bus-cos',
  templateUrl: './customer-bus-cos.component.html',
  styleUrls: ['./customer-bus-cos.component.css']
})
export class CustomerBusCosComponent implements OnInit {
    custNo;

    public setting?: Setting;

    public itemsListCustomerCompanies: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadSetting() {
        if (!!this.custNo) {
            this.setting = (await this.datatask.Post(1294, { cust_no: this.custNo }))[0];
        }
    }

    private async loadCustomerCompanies() {
        if (!this.setting) return;

        this.itemsListCustomerCompanies = await this.datatask.Post(1292, {
            cust_no: this.setting.cust_no,
            gb_customerbuscos: this.setting.gb_customerbuscos
        });
    }

    public onTabChanged() {
        this.loadCustomerCompanies();
    }

    private async init() {
        await this.loadSetting();
        this.loadCustomerCompanies();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    cust_no: string;
    gb_customerbuscos: string;
}
